import React from 'react';
import { Zap } from 'lucide-react';

interface ChaloAIIconProps {
  size?: number;
  className?: string;
}

export const ChaloAIIcon: React.FC<ChaloAIIconProps> = ({ 
  size = 24, 
  className = "text-white" 
}) => {
  return (
    <div className={`w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 ${className}`}>
      <Zap className={`w-${Math.floor(size/6)} h-${Math.floor(size/6)} text-white`} />
    </div>
  );
};

interface LogoProps {
  size?: number;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 30, className = '' }) => {
  return (
    <img
      src={'/Logo_Duri.png'}
      alt="Duri App Logo"
      className={className}
      style={{ height: size, width: 'auto', display: 'block' }}
    />
  );
};
